import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo6/andes.png";
import Imagen2 from "../../../images/modulo6/himno2.png";
import Imagen3 from "../../../images/modulo6/himno3.png";
import Imagen4 from "../../../images/modulo6/himno4.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo6 } from "../../../routes/Module6";
import Sidebar from "../Sidebar";
import Card from "../../../components/Card";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo6/Actividad 5.mp3";

const Actividad5 = () => {
  const infoUnidad = modulo6.content[0];
  const infoAct = modulo6.content[0].activities[4];
  const crumbs = [
    {
      title: modulo6.title,
      url: "/" + modulo6.url,
    },
    {
      title:
        modulo6.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo6.content[0].activities[5].name}`,
    linkNext: `${modulo6.url}/${modulo6.content[0].path}/${modulo6.content[0].activities[5].path}`,
    titlePrev: `${modulo6.content[0].activities[3].name}`,
    linkPrev: `${modulo6.url}/${modulo6.content[0].path}/${modulo6.content[0].activities[3].path}`,
  };

  const metadata = {
    color: modulo6.color,
    title: `${modulo6.title} - ${infoAct.name}`,
    name: modulo6.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo6.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
      <AudioPlayer track={Audio} />

      <ul className="mb-5">
        <li>Lee la letra de la estrofa del himno que cantamos usualmente.</li>
        <li>
          Ayúdate por las ilustraciones para entenderla y luego responde las
          preguntas.
        </li>
      </ul>
      <Card>
        <div className="row align-items-center justify-content-center">
          <div className="col-md-4 col-xs-12">
            <p className="fs-5 p-md-0 p-4">
              En su cima los Andes sostengan la bandera o pendón bicolor
            </p>
          </div>
          <div className="col-md-6 col-xs-12">
            <img src={Imagen1} alt="Himno" className="img-fluid" />
          </div>
        </div>
      </Card>
      <Card>
        <div className="row align-items-center justify-content-center">
          <div className="col-md-4 col-xs-12">
          <p className="fs-5 p-md-0 p-4">
              que a los siglos anuncie el esfuerzo que ser libres por siempre
              nos dio.
            </p>
          </div>
          <div className="col-md-6 col-xs-12">
            <img src={Imagen2} alt="Himno" className="img-fluid" />
          </div>
        </div>
      </Card>
      <Card>
        <div className="row align-items-center justify-content-center">
          <div className="col-md-4 col-xs-12">
          <p className="fs-5 p-md-0 p-4">
A su sombra vivamos tranquilos</p>
          </div>
          <div className="col-md-6 col-xs-12">
            <img src={Imagen3} alt="Himno" className="img-fluid" />
          </div>
        </div>
      </Card>
      <Card>
        <div className="row align-items-center justify-content-center">
          <div className="col-md-4 col-xs-12">
          <p className="fs-5 p-md-0 p-4">
              y al nacer por sus cumbres el sol renovemos el gran juramento que
              rendimos al dios de Jacob.
            </p>
          </div>
          <div className="col-md-6 col-xs-12">
            <img src={Imagen4} alt="Himno" className="img-fluid" />
          </div>
        </div>
      </Card>

      <div className="row my-5 align-items-center">
        <div className="col-md-8 col-xs-12">
          <p>¿Qué parte del territorio peruano destaca esta estrofa?</p>
          <input type="text" className="form-control mb-4" />

          <p>¿Qué valor destacan esta estrofa y el coro del himno?</p>
          <input type="text" className="form-control" />
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Pida que describan las imágenes y ayude a
          entender la estrofa del himno. En la segunda imagen está Vizcardo y
          Guzmán, precursor de la Independencia con su “Carta a los españoles
          americanos”. Las respuestas a las preguntas son los Andes y la
          libertad. Dialoguen acerca de su importancia.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad5;
